// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f991f1b35235cb88bc301096e46d201dd8ac44e3/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};